import React, { useState } from 'react';
import { Button } from './common/Button';
import { Popup } from './common/Popup';
import { CheckIcon, ShoppingBagIcon } from 'lucide-react';
export function SplitSection() {
  const [showPopup, setShowPopup] = useState(false);
  const handleDownloadClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowPopup(true);
  };
  const handleOkClick = () => {
    setShowPopup(false);
  };
  const shopperBenefits = ['Automatic rewards at your local spots', 'No coupon codes to search when shopping', 'Discover new local favorites', 'Special perks for loyal customers', 'Share with friends for bonus perks'];
  const merchantBenefits = ['No hardware or special equipment needed', 'Works with your existing payment system', 'Detailed customer insights dashboard', 'Customizable reward programs', 'Increase repeat customer visits'];
  const brandBenefits = ['Sponsor in-store perks', 'Run Drops for new products & offers', 'Personalised perks for repeat buyers', 'Activate underperforming stores', 'Turn cafés into sampling channels'];
  return <div className="bg-white" data-id="element-529" data-mp="2y5ul1tbf3bdt">
      {/* Merchants Section */}
      <section id="merchants" className="py-24 bg-[#F9F9F6] border-b border-gray-100" data-id="element-530" data-mp="3bw7uk03yiy59">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-531" data-mp="374ptzd5uizkt">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-532" data-mp="3ltvlsg2ctnio">
            <div className="lg:w-1/2" data-id="element-533" data-mp="3lvynhxcvd538">
              <div className="inline-block bg-[#1A1A1A] px-4 py-1 rounded-full text-sm font-bold text-white mb-6" data-id="element-534" data-mp="3gvalkgn3r3u8">
                FOR MERCHANTS
              </div>
              <h2 className="text-4xl sm:text-5xl font-black mb-8 text-[#1A1A1A] uppercase tracking-tight" data-id="element-535" data-mp="3usfxuydesyxx">
                Grow Your Business
              </h2>
              <ul className="space-y-4 mb-10" data-id="element-536" data-mp="20hapjgrdnyc9">
                {merchantBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-537" data-mp="1wgiechyy3jdc" data-mpi={index}>
                    <div className="bg-[#FFFC00] rounded-full p-1.5 mr-4 mt-1 flex-shrink-0 border border-[#1A1A1A]" data-id="element-538" data-mp="3vk7hcwydzhyy">
                      <CheckIcon className="h-4 w-4 text-[#1A1A1A] stroke-[3]" data-id="element-539" data-mp="4eftk4830hfb" />
                    </div>
                    <span className="text-xl text-gray-700 font-medium" data-id="element-540" data-mp="9bobq4t8clgk">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
              <Button variant="outline" size="lg" href="https://kraya.shop/" data-id="element-541" data-mp="ic4e1ay8lmju">
                Partner With Us
              </Button>
            </div>
            <div className="lg:w-1/2" data-id="element-542" data-mp="n9w3lybeswkv">
              <div className="relative aspect-square" data-id="element-543" data-mp="s2paarqfuezl">
                <div className="absolute inset-0 bg-[#1A1A1A] rounded-[3rem] transform -translate-x-4 translate-y-4" data-id="element-544" data-mp="s5bf4jly2ge4"></div>
                <img src="https://cdn.magicpatterns.com/uploads/fxQHPTQDeoT5H44M7fgzzE/1d79ecf3086084ff597ef63c5ec6c04c.jpg" alt="Weekend café exterior" className="absolute inset-0 w-full h-full object-cover rounded-[3rem] border-4 border-[#1A1A1A] bg-white" data-id="element-545" data-mp="121eni77e3b9i" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shoppers Section */}
      <section id="shoppers" className="py-24" data-id="element-546" data-mp="2hkmehfy06pkn">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-547" data-mp="2cl9gbz1olw2r">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-548" data-mp="2cmuerzr49z5w">
            <div className="lg:w-1/2 order-2 lg:order-1" data-id="element-549" data-mp="3a7gmvehjpyhr">
              <div className="relative aspect-square" data-id="element-550" data-mp="359x90forfnqc">
                <div className="absolute inset-0 bg-[#1A1A1A] rounded-[3rem] transform translate-x-4 translate-y-4" data-id="element-551" data-mp="35agq5u6l683b"></div>
                <img src="https://cdn.magicpatterns.com/uploads/oSnyo2cVrZMg8UMHRtjE85/sxy.jpg" alt="Shopper using rewards app" className="absolute inset-0 w-full h-full object-cover rounded-[3rem] border-4 border-[#1A1A1A] bg-white" data-id="element-552" data-mp="30glzu7wh6uv9" />
              </div>
            </div>
            <div className="lg:w-1/2 order-1 lg:order-2" data-id="element-553" data-mp="38q9t8rgibbw5">
              <div className="inline-block bg-[#FFFC00] border-2 border-[#1A1A1A] px-4 py-1 rounded-full text-sm font-bold text-[#1A1A1A] mb-6" data-id="element-554" data-mp="38sw00ovkpndb">
                FOR SHOPPERS
              </div>
              <h2 className="text-4xl sm:text-5xl font-black mb-8 text-[#1A1A1A] uppercase tracking-tight" data-id="element-555" data-mp="2yuonci8bhrh4">
                Earn While You Spend
              </h2>
              <ul className="space-y-4 mb-10" data-id="element-556" data-mp="3ric7xx9l8i3r">
                {shopperBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-557" data-mp="a6ksjhklj6r" data-mpi={index}>
                    <div className="bg-[#1A1A1A] rounded-full p-1.5 mr-4 mt-1 flex-shrink-0" data-id="element-558" data-mp="3hrzlfzi7qeuz">
                      <CheckIcon className="h-4 w-4 text-[#FFFC00] stroke-[3]" data-id="element-559" data-mp="3mpj030itotng" />
                    </div>
                    <span className="text-xl text-gray-700 font-medium" data-id="element-560" data-mp="ea7lnyxu4qm8">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
              <Button variant="primary" size="lg" onClick={handleDownloadClick} data-id="element-561" data-mp="23r3ba8p6dwkt">
                Join Waitlist
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Popup isOpen={showPopup} onClose={() => setShowPopup(false)} title={<div className="flex items-center gap-2" data-id="element-563" data-mp="28htfvjps1veg">
            <span className="font-bold text-xl" data-id="element-564" data-mp="28kfv85iwtf78">Note</span>
          </div>} data-id="element-562" data-mp="2ckg7pkmg7gbn">
        <div className="space-y-6" data-id="element-565" data-mp="1kt0qk63nulst">
          <p className="text-gray-600 text-lg font-medium" data-id="element-566" data-mp="1ftxiecsdvzgm">
            Please join our waitlist and get referral rewards. We are launching
            soon!
          </p>
          <Button variant="primary" size="full" href="https://kraya.live/" onClick={handleOkClick} data-id="element-567" data-mp="1trce1z98d3h1">
            Join Waitlist
          </Button>
        </div>
      </Popup>
    </div>;
}